export const navigationSliceName = "navigation";

export const navigationInitState = {
  shortcutOpen: false,
  items: [],
};
